const appName = process.env.MGDX_APP_NAME || "unknown";

export default appName;
